import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { CircularProgress, MenuItem } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import TextField from "@mui/material/TextField";
import useApi from "../hooks/useApi";
import { CirclePlus } from "lucide-react";
import { PiFunnel } from "react-icons/pi";
import PaginationControls from "../components/lead_and_quotation/PaginationControls";
import ReusableTable from "../components/lead_and_quotation/TableListViewFull";
import QuotationReportPopup from "./QuotationReportPopup";

const QuotationsListViewFull = () => {
  const [showQuotationReportPopup, setShowQuotationReportPopup] =
    useState(false);

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const empIDFromUserObjectInLocalStorage = currentUserObject[0]?.EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  let defaultStage = "-";

  if (userAccessGroup?.trim().toUpperCase() === "ADMIN") {
    // defaultStage = "For Approval" earlier
    defaultStage = "-";
  }

  const [currentSelectedStage, setCurrentSelectedStage] =
    useState(defaultStage);

  const [initialFilterObject, setInitialFilterObject] = useState({
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATORTH" &&
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
      userAccessGroup?.trim().toUpperCase() != "ADMIN" &&
      userAccessGroup?.trim().toUpperCase() != "CADMIN" &&
      userAccessGroup?.trim().toUpperCase() != "CACCOUNTS" &&
      userAccessGroup?.trim().toUpperCase() != "C STORES" &&
      userAccessGroup?.trim().toUpperCase() != "C ACC JUNIOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    task_owner_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATORTH" &&
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
      userAccessGroup?.trim().toUpperCase() != "ADMIN" &&
      userAccessGroup?.trim().toUpperCase() != "CADMIN" &&
      userAccessGroup?.trim().toUpperCase() != "CACCOUNTS" &&
      userAccessGroup?.trim().toUpperCase() != "C STORES" &&
      userAccessGroup?.trim().toUpperCase() != "C ACC JUNIOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    free_text: "-",
  });

  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [quotationList, setQuotationList] = useState(null);
  const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const callApi = () => {
    console.log("currentPageNumber ", currentPageNumber);

    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    if (!currentUserObject) {
      console.error("No user data found in localStorage");
      return;
    }

    const userAccessGroup = currentUserObject[0].accessgrp;

    console.log("currentUserDepartment:", currentUserDepartment);
    console.log("userAccessGroup:", userAccessGroup);

    fetchQuotationList(
      userAccessGroup,
      currentUserDepartment,
      initialFilterObject
    );
  };

  useEffect(() => {
    if (currentPageNumber) {
      callApi();
    }
  }, [currentPageNumber]);

  useEffect(() => {
    if (initialFilterObject) {
      console.log("freetext changed calling api");
      callApi();
    }
  }, [initialFilterObject]);
  const {
    request: requestQuotationList,
    loading: loadingQuotationList,
    error: errorQuotationList,
  } = useApi();

  const USER_ACCESS = currentUserObject[0]?.useraccess ?? "";

  let reportSalesPersonId = empIDFromUserObjectInLocalStorage;
  let reportCreatorId = empIDFromUserObjectInLocalStorage;

  if (USER_ACCESS.indexOf("ZK") === -1) {
    reportSalesPersonId =
      initialFilterObject?.task_owner_id &&
      initialFilterObject.task_owner_id !== "-"
        ? initialFilterObject.task_owner_id
        : "-";
  }

  if (USER_ACCESS.indexOf("ZM") === -1) {
    reportCreatorId =
      initialFilterObject?.task_creator_id &&
      initialFilterObject.task_creator_id !== "-"
        ? initialFilterObject.task_creator_id
        : "-";
  }

  const fetchQuotationList = async (
    userAccessGroup,
    currentUserDepartment,
    filterObjectFromModal
  ) => {
    console.log(
      "filterObjectFrom Modal and userAccessGroup>>",
      filterObjectFromModal,
      userAccessGroup
    );

    setLoading(true);

    try {
      let url = "";

      // if (
      //   userAccessGroup?.trim().toUpperCase() === "COORDINATOR" ||
      //   userAccessGroup?.trim().toUpperCase() === "ADMIN" ||
      //   userAccessGroup?.trim().toUpperCase() === "CADMIN" ||
      //   userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" ||
      //   userAccessGroup?.trim().toUpperCase() == "C STORES" ||
      //   userAccessGroup?.trim().toUpperCase() == "C ACC JUNIOR"
      // ) {
      //   url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskMainListFilter/${company_code_from_local_storage}/ProposalFilter/${idOfSalesPersonToPassInAPI}/${filterObjectFromModal.task_creator_id}/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      // } else {
      //   url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskMainListFilter/${company_code_from_local_storage}/ProposalFilter/${idOfSalesPersonToPassInAPI}/-/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      // }

      const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
      const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

      let idOfSalesPersonToPassInAPI = empIDFromUserObjectInLocalStorage; // filterObjectFromModal.task_salesperson earlier

      let idOfCreatorViewToPassInAPI = empIDFromUserObjectInLocalStorage;

      const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
        ? JSON.parse(localStorage.getItem("currentUser"))
        : "";

      const USER_ACCESS = CURRENT_USER_OBJECT[0]?.useraccess;
      if (USER_ACCESS.indexOf("ZK") !== -1) {
        console.log("String is present, that means salesperson view");
        // just pass sales person because OO is present
      } else {
        if (
          filterObjectFromModal?.task_owner_id &&
          filterObjectFromModal?.task_owner_id != "-"
        ) {
          idOfSalesPersonToPassInAPI = filterObjectFromModal?.task_owner_id;
        } else {
          idOfSalesPersonToPassInAPI = "-";
        }
      }

      if (USER_ACCESS.indexOf("ZM") !== -1) {
        console.log("String is present, that means creator view");
        // just pass sales person because OO is present
      } else {
        if (
          filterObjectFromModal?.task_creator_id &&
          filterObjectFromModal?.task_creator_id != "-"
        ) {
          idOfCreatorViewToPassInAPI = filterObjectFromModal?.task_creator_id;
        } else {
          idOfCreatorViewToPassInAPI = "-";
        }
      }

      let stageToPassToAPI = currentSelectedStage;

      // controller is CRMTaskMainListFilter confirmed

      // salesperson owner id
      // coordinator as  creator id
      //  area codes tage

      // url path structure is CRMTaskMainListFilter/cmpcode/mode/task_owner_id/task_creator_id/job_code/taskid/task_owner_department/datfrom/ dateto/freetext/priority/stage in place of priority pagination number is passed

      url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskMainListFilter/${company_code_from_local_storage}/ProposalFilter/${idOfSalesPersonToPassInAPI}/${idOfCreatorViewToPassInAPI}/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${stageToPassToAPI}`;

      const response = await requestQuotationList({
        url: url,
        method: "GET",
        timeout: 5000,
      });
      console.log("Quotation List:", response);
      setQuotationList(response);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {};

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  // this two functions can be merged if needed because previous_page_url_last_part was initially thought as a way to check if it is from admin page
  // this variable previous_page_url_last_part just console logged in Quotelead , now in Salestab we check if admin then only shows approve button so no use of this variable
  const goToAdminQuotationPage = (clickedListItem) => {
    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_account: clickedListItem.Account,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_coordinator: clickedListItem.Coordinator,
      deptno: clickedListItem.Dept,
      lead_email: clickedListItem.lead_email,
    };
    console.log("selectedLead>>> Admin List", selectedLead);

    navigate(`/quoteLead`, { state: { selectedLead } });
  };

  const goToUserQuotationPage = (clickedListItem) => {
    console.log("clickedListItem ", clickedListItem);

    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_coordinator: clickedListItem.Coordinator,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_account: clickedListItem.Account,
      deptno: clickedListItem.Dept,
      lead_email: clickedListItem.lead_email,
    };
    console.log("selectedLead>>>", selectedLead);

    let previous_page_url_last_part = { name: "quotationsListViewFull" };

    navigate("/quoteLead", {
      state: { selectedLead, previous_page_url_last_part },
    });
  };

  const handleInput = (e) => {
    if (e.target.value === "") {
      setInitialFilterObject((prev) => ({ ...prev, free_text: "-" }));
    } else {
      setInitialFilterObject((prev) => ({
        ...prev,
        free_text: [e.target.value],
      }));
    }
  };

  const handleChange = (e) => {
    setCurrentSelectedStage(e.target.value);
  };

  useEffect(() => {
    if (currentSelectedStage) {
      callApi();
    }
  }, [currentSelectedStage]);

  const {
    response: requestPreCodeItemPresent,
    loading: loadingPreCodeItemPresent,
    error: errorPrecodeItemPresent,
  } = useApi();

  const handleNavigateToSalesOrderCreation = (item) => {
    console.log(`Navigating to Sales Order from :`, item);

    navigate("/sales_order", {
      state: {
        mode: "new",
        transferredFrom: "QUOT",
        transferData: [item],
        shouldFetchTransfer: true,
      },
    });
  };
  const quotationDetailsConfig = {
    columns: [
      { header: "Quotation Number", accessor: "Prop_No" },
      { header: "Lead Id", accessor: "Lead_ID" },
      { header: "Date", accessor: "Date", type: "date" },
      { header: "Rev No", accessor: "jv_num" },
      { header: "Customer Name", accessor: "Customer" },
      { header: "Customer Account", accessor: "Account" },
      { header: "Amount", accessor: "Amount" },
      {
        header: "Salesperson",
        accessor: "Sales_Person",
        render: (value, item) => (
          <div>
            <p>{item.Sales_Person}</p>
            <p>{item.Sales_person_Name}</p>
          </div>
        ),
      },
      { header: "Project name", accessor: "Project" },
      { header: "Dept No", accessor: "Dept" },
      { header: "Status", accessor: "Stage", type: "status" },
      {
        header: "Action",
        type: "actions",
        headerClassName: "text-center w-[240px]",
        actionLayout: "justify-between",
        actions: [
          {
            label: "Quotation Details",
            className:
              "bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs",
            condition: (item, userGroup) =>
              userGroup?.trim().toUpperCase() === "ADMIN" ||
              userGroup?.trim().toUpperCase() === "CADMIN",
            onClick: (item) => goToAdminQuotationPage(item),
          },
          {
            label: "Quotation Details",
            className:
              "bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs",
            condition: (item, userGroup) =>
              !(
                userGroup?.trim().toUpperCase() === "ADMIN" ||
                userGroup?.trim().toUpperCase() === "CADMIN"
              ),
            onClick: (item) => goToUserQuotationPage(item),
          },
          {
            label: "Convert to Sales Order",
            loadingText: "Converting...",
            className:
              "bg-gray-500 text-white rounded hover:bg-gray-600 text-xs p-1",
            condition: (item) => item.Stage === "Won -Sales Order",
            loading: () => loadingPreCodeItemPresent,
            onClick: (item) => handleNavigateToSalesOrderCreation(item),
          },
        ],
      },
    ],
  };

  return (
    <div className=" px-6 overflow-x-auto lg:w-full w-[100vw]">
      <div className="flex lg:items-center lg:flex-row flex-col justify-between ">
        <div className="flex space-x-4 items-center w-full lg:justify-start justify-between">
          <h3 className="text-xl font-normal text-gray-800 ">
            Quotations List
          </h3>
          <Link
            to={"/quoteLead"}
            className=" p-2 bg-blue-500  hover:bg-blue-600  text-white  transition-colors duration-300 rounded flex items-center gap-1 font-semibold text-sm"
          >
            {" "}
            <span>
              <CirclePlus size={20} />{" "}
            </span>
            Add New
          </Link>

          <button
            onClick={() => setShowQuotationReportPopup((prev) => !prev)}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
          >
            <svg
              className="h-4 w-4 text-slate-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            View Report
          </button>
          
        </div>{" "}
        <div className="flex flex-col lg:flex-row lg:flex-wrap lg:justify-end items-center gap-3 p-2 w-full">
          {/* Stage Selector */}
          <div className="w-full lg:w-auto">
            <TextField
              select
              label="Stage"
              name="territory"
              value={currentSelectedStage}
              onChange={handleChange}
              fullWidth
              variant="standard"
              id="territory"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Stage
              </MenuItem>
              <MenuItem value="-">All</MenuItem>
              <MenuItem value="Draft">Draft</MenuItem>
              <MenuItem value="For Approval">For Approval</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Customer Submission & Awaiting Approval">
                Customer Submission & Awaiting Approval
              </MenuItem>
              <MenuItem value="Customer Approval">Customer Approval</MenuItem>
              <MenuItem value="Customer Negotiation">
                Customer Negotiation
              </MenuItem>
              <MenuItem value="Lost-Customer Rejection">
                Customer Rejection
              </MenuItem>
            </TextField>
          </div>

          {/* Search Input */}
          <div className="w-full lg:w-auto flex justify-between  gap-2">
            <input
              className="w-full lg:w-auto border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Search in Quotation"
              onChange={(e) => handleInput(e)}
            />
            <button
              onClick={() => setShowLeadFilter((prev) => !prev)}
              className="flex items-center gap-2 text-sm px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 transition"
            >
              <PiFunnel size={20} className="text-gray-500" />
            </button>

            {/* NEW – Download Report button */}
            {/* <button
  onClick={downloadReport}
  disabled={reportLoading}
  className="flex items-center gap-2 text-sm px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
>
  {reportLoading ? "Generating..." : "⬇ Download Report"}
</button> */}
          </div>

          <div className="w-full flex justify-center lg:justify-end lg:mt-0 mt-3">
            <PaginationControls
              setCurrentPageNumber={setCurrentPageNumber}
              currentPageNumber={currentPageNumber}
              data={quotationList}
              itemsPerPage={100}
            />
          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <ReusableTable
          data={quotationList}
          columns={quotationDetailsConfig.columns}
          currentUserAccessGroup={currentUserAccessGroup}
          loadingPreCodeItemPresent={loadingPreCodeItemPresent}
        />
      </div>
      {loading ? (
        <p className="inset-0 fixed flex justify-center items-center">
          Loading quotations... <CircularProgress size={24} />
        </p>
      ) : (
        <ul>
          {/* {quotationList?.map((quote, index) => (
            <li key={index}>{quote.name}</li>
          ))} */}
        </ul>
      )}

      {showLeadFilter && (
        <QuotationListFilterModal
          applyFilters={applyFilters}
          closeFilter={() => setShowLeadFilter(false)}
          fetchQuotationList={fetchQuotationList}
          currentSelectedStage={currentSelectedStage}
          setCurrentSelectedStage={setCurrentSelectedStage}
        />
      )}

      {showQuotationReportPopup && (
        <QuotationReportPopup
          onClose={() => setShowQuotationReportPopup(false)}
          fetchQuotationList={fetchQuotationList}
        />
      )}
    </div>
  );
};

export default QuotationsListViewFull;
